import {Header, PageOrientation, Paragraph, SectionType, Footer, TextRun, AlignmentType, PageNumber} from "docx";
import {conclusionTableBerlin} from "./conclusionTableBerlin";
import {gutachterSectionArray} from "./gutachterSectionArray";
import {headerTable1, headerTable2} from "./headerTables";
import {leseschwache} from "./leseschwaeche";
import {mainTable1} from "./mainTable1";
import {mainTable2Berlin} from "./mainTable2Berlin";
import {paragraphArial, paragraphArialBold, paragraphArialBoldPageBreak} from "./paragraphs";

export const sectionsBerlin = (user, klausur, schueler, textbausteine, companies) => {
  const defaultHeader = new Header({
    children: [
      headerTable1(user, klausur, schueler),
      new Paragraph(""),
      headerTable2(user, klausur, schueler, companies),
      new Paragraph("")
    ]
  });
  return [
    {
      properties: {
        titlePage: true,
        page: {
          type: SectionType.CONTINUOUS,
          size: {
            orientation: PageOrientation.PORTRAIT
          },
          margin: {
            top: 400,
            right: 400,
            bottom: 400,
            left: 400
          }
        }
      },

      headers: {
        default: defaultHeader,
        first: defaultHeader
      },
      footers: {
        first: new Footer({
          children: []
        }),
        default: new Footer({
          children: [
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  font: "arial",
                  children: ["Seite ", PageNumber.CURRENT, " von ", PageNumber.TOTAL_PAGES]
                })
              ]
            })
          ]
        })
      },

      children: [
        paragraphArialBold("Aufgabenbearbeitung"),
        mainTable1(user, klausur, schueler, textbausteine),
        paragraphArialBold("Sprachverwendung"),
        mainTable2Berlin(user, klausur, schueler, textbausteine),
        paragraphArialBold(schueler.zusammenfassung ? "Zusammenfassende Beurteilung / Bemerkungen" : ""),
        paragraphArial(schueler.zusammenfassung),
        paragraphArialBoldPageBreak("Gesamtbewertung"),
        conclusionTableBerlin(schueler, klausur),
        ...leseschwache(schueler.leseschwaeche),
        ...gutachterSectionArray(schueler, klausur, companies, user)
      ]
    }
  ];
};
